import { render, staticRenderFns } from "./GlobalEmpty.vue?vue&type=template&id=2b2b3f78&"
import script from "./GlobalEmpty.vue?vue&type=script&lang=js&"
export * from "./GlobalEmpty.vue?vue&type=script&lang=js&"
import style0 from "./GlobalEmpty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports